import { Nullable } from '@utils/util.types';
import { userContext } from '@utils/hyperdx';
import Cookies from 'js-cookie';
import { create } from 'zustand';

interface AuthStore {
	accessToken: Nullable<string>;
	refreshToken: Nullable<string>;
	logout: () => void;
	error: Nullable<string>;
	setAccessToken: (accessToken: string, refreshToken?: string) => void;
}

export const useAuthStore = create<AuthStore>((set, get) => ({
	accessToken: null,
	refreshToken: null,
	error: null,
	user: null,
	setAccessToken: (accessToken: string, refreshToken = '') => {
		const currentState = get();
		if (currentState.accessToken === accessToken && currentState.refreshToken === refreshToken) {
			return;
		}

		if (!accessToken || accessToken.trim().length === 0) {
			console.error('Attempted to set empty access token');
			return;
		}

		try {
			Cookies.set('accessToken', accessToken, { secure: true });
			localStorage.setItem('refreshToken', refreshToken || '');
			
			set({
				accessToken: accessToken,
				refreshToken: refreshToken || '',
				error: null,
			});
		} catch (error) {
			console.error('Failed to store tokens:', error);
			set({ error: 'Failed to store authentication tokens' });
		}
	},

	logout: () => {
		try {
			Cookies.remove('accessToken');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('user');
			
			// Clear user context from HyperDX
			userContext.clearUser();
			
			set({ accessToken: null, refreshToken: null, error: null });
		} catch (error) {
			console.error('Error during logout:', error);
			set({ accessToken: null, refreshToken: null, error: null });
		}
	},
}));
